const errorCodes = {
    4001: "当前店铺数据已存在!",
};

export default errorCodes;
